import React, { useState, useRef, useEffect } from 'react';
import { gsap } from 'gsap';
// import gImg1 from '../../Assets/fHome.png';
import gImg2 from '../../Assets/missanHome.avif';
import gImg3 from '../../Assets/missanServ.avif';
import gImg4 from '../../Assets/lawyer.avif';
import gImg5 from '../../Assets/entity.avif';
import gImg6 from '../../Assets/trendlineeg.avif';
import gImg7 from '../../Assets/hamasat.avif';
import gImg8 from '../../Assets/premium.avif';
import gImg9 from '../../Assets/rams.avif';
import gImg10 from '../../Assets/weavr.avif';
import './Gallery.css';
import { Link } from 'react-router-dom';

const Gallery = () => {
    const [currentImage, setCurrentImage] = useState(0);
    const [zIndices, setZIndices] = useState([9, 8, 7, 6, 5, 4, 3, 2, 1]);
    const [transitioning, setTransitioning] = useState(false);
    const [animationTriggered, setAnimationTriggered] = useState(false); // New state
    const startX = useRef(0);
    const startY = useRef(0);
    const containerRef = useRef(null);

    const images = [
        // { id: 1, img: gImg1 },
        { id: 2, img: gImg2 },
        { id: 3, img: gImg3 },
        { id: 4, img: gImg4 },
        { id: 5, img: gImg5 },
        { id: 6, img: gImg6 },
        { id: 7, img: gImg7 },
        { id: 8, img: gImg8 },
        { id: 9, img: gImg9 },
        { id: 10, img: gImg10 },
    ];

    const getOffset = (index) => {
        const offsetStep = 5;
        const xOffset = index * offsetStep;
        const yOffset = index * offsetStep;
        return { x: `${xOffset}px`, y: `${yOffset}px` };
    };

    const handleStart = (x, y) => {
        startX.current = x;
        startY.current = y;
    };

    const handleEnd = (x, y) => {
        if (transitioning) return;

        const deltaX = x - startX.current;
        const deltaY = y - startY.current;
        const swipeThreshold = 50;
        let newIndex = currentImage;

        if (Math.abs(deltaX) > swipeThreshold || Math.abs(deltaY) > swipeThreshold) {
            if (deltaX < -swipeThreshold) {
                newIndex = (currentImage + 1) % images.length;
            } else if (deltaX > swipeThreshold) {
                newIndex = (currentImage - 1 + images.length) % images.length;
            }
        }

        if (newIndex !== currentImage) {
            setTransitioning(true);
            const timeline = gsap.timeline({
                onComplete: () => {
                    setCurrentImage(newIndex);
                    setTransitioning(false);

                    setZIndices((prevZIndices) => {
                        const newZIndices = [...prevZIndices];
                        for (let i = 0; i < newZIndices.length; i++) {
                            if (i === currentImage) {
                                newZIndices[i] = 1;
                            } else {
                                newZIndices[i] = newZIndices[i] + 1 > 9 ? 9 : newZIndices[i] + 1;
                            }
                        }
                        return newZIndices;
                    });
                }
            });

            const cards = document.querySelectorAll('.Gcard-stack .Gcard');

            timeline
                .to(cards, {
                    duration: 0.4,
                    x: (i) => (i === currentImage ? (deltaX < -swipeThreshold ? '-150%' : '150%') : (deltaX < -swipeThreshold ? '150%' : '-150%')),
                    y: (i) => (i === currentImage ? (deltaY < -swipeThreshold ? '-150%' : '-150%') : getOffset(i).y),
                    rotateZ: (i) => (i === currentImage ? (deltaX < -swipeThreshold ? '-30deg' : '30deg') : '0deg'),
                    scale: (i) => (i === currentImage ? 0.005 : 0.8),
                    ease: 'power2.inOut'
                })
                .to(cards, {
                    duration: 0.4,
                    x: (i) => (i === newIndex ? getOffset(i).x : getOffset(i).x),
                    y: (i) => (i === newIndex ? getOffset(i).y : getOffset(i).y),
                    rotateZ: '0deg',
                    scale: 1,
                    ease: 'power2.inOut'
                });
        }
    };

    const handleMouseDown = (e) => {
        handleStart(e.clientX, e.clientY);
    };

    const handleMouseMove = (e) => {
        // Implement mouse move if needed
    };

    const handleMouseUp = (e) => {
        handleEnd(e.clientX, e.clientY);
    };

    const handleTouchStart = (e) => {
        const touch = e.touches[0];
        handleStart(touch.clientX, touch.clientY);
    };

    const handleTouchEnd = (e) => {
        const touch = e.changedTouches[0];
        handleEnd(touch.clientX, touch.clientY);
    };

    useEffect(() => {
        const maxZIndex = Math.max(...zIndices);
        const topImageIndex = zIndices.indexOf(maxZIndex);
        setCurrentImage(topImageIndex);
    }, [zIndices]);

    useEffect(() => {
        const handleIntersection = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !animationTriggered) {
                    setAnimationTriggered(true); // Mark animation as triggered

                    const timeline = gsap.timeline({
                        onComplete: () => {
                            setTransitioning(false);

                            // setZIndices((prevZIndices) => {
                            //     const newZIndices = [...prevZIndices];
                            //     for (let i = 0; i < newZIndices.length; i++) {
                            //         if (i === currentImage) {
                            //             newZIndices[i] = 1;
                            //         } else {
                            //             newZIndices[i] = newZIndices[i] + 1 > 10 ? 10 : newZIndices[i] + 1;
                            //         }
                            //     }
                            //     return newZIndices;
                            // });
                        }
                    });

                    const cards = document.querySelectorAll('.Gcard-stack .Gcard');

                    timeline
                        .to(cards, {
                            duration: 0.4,
                            delay: 1,
                            x: (i) => (i === 0 ? '-150%' : '150%'), // Only animate first image
                            y: (i) => (i === 0 ? '-150%' : getOffset(i).y),
                            rotateZ: (i) => (i === 0 ? '-30deg' : '0deg'),
                            scale: (i) => (i === 0 ? 0.005 : 0.8),
                            ease: 'power2.inOut'
                        })
                        .to(cards, {
                            duration: 0.4,
                            x: (i) => getOffset(i).x,
                            y: (i) => getOffset(i).y,
                            rotateZ: '0deg',
                            scale: 1,
                            ease: 'power2.inOut'
                        });

                    observer.disconnect();
                }
            });
        };

        const observer = new IntersectionObserver(handleIntersection, {
            threshold: 0.5 // Adjust this value as needed
        });

        // Store the ref value in a local variable
        const currentElement = containerRef.current;

        if (currentElement) {
            observer.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                observer.unobserve(currentElement);
            }
        };
    }, [currentImage, animationTriggered]);
    return (

        <div
            className='Gallery'
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            <div className='GalleryHead'>
                <div style={{ textAlign: 'center' }}>
                    <h5 data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="650"
                        data-aos-offset="170" >Gallery</h5>
                    <h2 data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="850"
                        data-aos-offset="170">Swipe My Recent Work</h2>
                </div>
            </div>
            <div className="Gcontainer"
                ref={containerRef}
            >
                <div className="Gcard-stack">

                    {images.map((image, index) => {
                        const offset = getOffset(index);
                        return (
                            <div
                                key={image.id}
                                id={image.id}
                                className={`Gcard ${index === currentImage ? 'visible' : ''}`}
                                style={{
                                    backgroundImage: `url(${image.img})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    transform: `translate(${offset.x},${offset.y})`,
                                    zIndex: zIndices[index] // Apply dynamic z-index
                                }}
                            ></div>
                        );
                    })}
                </div>
            </div>
            <Link className='see-more' to="/Gallery"> See More </Link>
        </div>

    );
};

export default Gallery;
